var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1077.6 200.4h-955.2c-46.801 0-85.199-38.398-85.199-85.199s38.398-85.199 85.199-85.199h954c46.801 0 85.199 38.398 85.199 85.199 0.003906 46.801-37.199 85.199-83.996 85.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1077.6 685.2h-955.2c-46.801 0-85.199-38.398-85.199-85.199s38.398-85.199 85.199-85.199h954c46.801 0 85.199 38.398 85.199 85.199 0.003906 46.801-37.199 85.199-83.996 85.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1077.6 1170h-955.2c-46.801 0-85.199-38.398-85.199-85.199s38.398-85.199 85.199-85.199h954c46.801 0 85.199 38.398 85.199 85.199 0.003906 46.801-37.199 85.199-83.996 85.199z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.b0331368dcca66853f22f4eb08683d4e.svg";
export { ForwardRef as ReactComponent };